import type { FanResponseDto } from '@api'
import { useUnit } from 'effector-react'
import { useMutation } from 'react-query'

import { useToast } from '@/components/ui/toast.tsx'
import { toggleRestrict } from '@/models/chattingUI/chats/chats.ts'
import { $creatorId } from '@/models/creators.ts'
import { chatsService } from '@/modules/chatting/service/chats.ts'
import { handleError } from '@/utils/error'

export function useToggleRestrict() {
  const creatorId = useUnit($creatorId)
  const toast = useToast()

  const restrictChatMutation = useMutation(
    (userId: FanResponseDto['id']) =>
      chatsService.restrictChat({ creatorId: creatorId!, userId }),
    {
      onSuccess: (_data, fanId) => {
        toast.success('Successfully restricted fan')
        toggleRestrict({ fanId, canSendMessage: false })
      },
      onError: (error) => {
        handleError(
          error,
          'Unexpected error occurred while restricting chat, please try again later',
        )
      },
    },
  )

  const unrestrictChatMutation = useMutation(
    (userId: FanResponseDto['id']) =>
      chatsService.unrestrictChat({ creatorId: creatorId!, userId }),
    {
      onSuccess: (_data, fanId) => {
        toast.success('Successfully unrestricted fan')
        toggleRestrict({ fanId, canSendMessage: true })
      },
      onError: (error) => {
        handleError(
          error,
          'Unexpected error occurred while unrestricting chat, please try again later',
        )
      },
    },
  )

  return {
    restrict: restrictChatMutation.mutateAsync,
    unrestrict: unrestrictChatMutation.mutateAsync,
    isRestrictLoading: restrictChatMutation.isLoading,
    isUnrestrictLoading: unrestrictChatMutation.isLoading,
  }
}
